//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';
import { MAX_NUMBER_OF_ITEMS_ACROSS_ALL_PAGES, NUM_ITEMS_PER_PAGE } from '@tagging/constants/taggingConstants';

export const getNumberOfPages = createSelector(
  (state: ICuralateStore) => state.tagging.feedReducer.totalFeedItemCount,
  (totalFeedItemCount: number) => {
    // Do not expose pages that would result in an offset of
    // MAX_NUMBER_OF_ITEMS_ACROSS_ALL_PAGES items or more
    const adjustedTotalFeedItemCount = Math.min(MAX_NUMBER_OF_ITEMS_ACROSS_ALL_PAGES, totalFeedItemCount);
    return Math.ceil(adjustedTotalFeedItemCount / NUM_ITEMS_PER_PAGE);
  },
);
